// src/pages/BillingPage.js
import React from "react";
import Sidebar from "../components/ui/Sidebar";
import PageHeader from "../components/ui/PageHeader";
import ButtonComponent from "../components/ui/ButtonComponent";
import BillingPanel from "../components/billing/BillingPanel";

import { Box, Card, CardContent } from "@mui/material";
import { useNavigate } from "react-router-dom";

const BillingPage = () => {
  const navigate = useNavigate();

  const breadcrumbs = (
    <span style={{ color: "#666" }}>
      <span
        style={{ cursor: "pointer", textDecoration: "underline" }}
        onClick={() => navigate("/settings")}
      >
        Settings
      </span>{" "}
      / Billing
    </span>
  );

  return (
    <div className="manage-users-container">
      <Sidebar />
      <div className="manage-users-content">
        <PageHeader
          title="Billing & Subscription"
          breadcrumbs={breadcrumbs}
          actions={
            <ButtonComponent
              label="Back to Settings"
              type="secondary"
              onClick={() => navigate("/settings")}
            />
          }
        />

        <Box sx={{ width: "100%", maxWidth: 800, mt: 4 }}>
          <Card>
            <CardContent>
              <BillingPanel embedded={false} showBanners allowStartSubscription />
            </CardContent>
          </Card>
        </Box>
      </div>
    </div>
  );
};

export default BillingPage;